import React, { Component } from "react";
import { withRouter } from "./withRouter";
import mapboxgl from "mapbox-gl";
import { tableFromIPC } from "apache-arrow";
import { Typography,Box, Stack, Select, Avatar,TextField,
    FormControl, InputLabel, MenuItem
 } from "@mui/material";
import MapComponent from "./MapComponent"
import ScatterDemogsChart from "./ScatterDemogsChart"



function getGroupKeys(polLevel) {
  if (polLevel === "past") {
    return [
      "past_vote_D66",
      "past_vote_CDA",
      //"past_vote_DidNotVote",
      "past_vote_GLpvdA",
      "past_vote_OtherCentre",
      "past_vote_OtherLeft",
      "past_vote_OtherRight",
      "past_vote_PVV",
      "past_vote_VVD",
    ];
  }

  // GE or LE
  const level = polLevel === "LE" ? "LE" : "GE";

  return [
    `D66_${level}_p`,
    `PVV_${level}_p`,
    `VVD_${level}_p`,
    `GLpvdA_${level}_p`,
    `CDA_${level}_p`,
    `OtherRight_${level}_p`,
    `OtherLeft_${level}_p`,
    `OtherCentre_${level}_p`,
  ];
}

export function baseColorForLikertKey(group, key) {
  const pol = group.polarity || {};
  // Find which polarity (pos/neg/neu) corresponds to this key
  const tag = Object.entries(pol).find(([polarity, polKey]) => polKey === key)?.[0];

  
  if (tag === "pos") return "#2E7D32";
  if (tag === "neg") return "#C62828";
  return "#6e6e6e";
}
const rowsFromTable = (table) => {
  const cols = table.schema.fields.map(f => f.name);
  const rows = [];
  for (let i = 0; i < table.numRows; i++) {
    const obj = {};
    for (const c of cols) obj[c] = table.getChild(c).get(i);
    rows.push(obj);
  }
  return rows;
};

// Define party full names and official colours
// Define party full names and official colours
const PARTY_INFO = {
  D66_GE_p: { name: "D66", color: "#2cc800" },
  D66_LE_p: { name: "D66", color: "#2cc800" },
  past_vote_D66: { name: "D66", color: "#2cc800" },

  PVV_GE_p: { name: "PVV", color: "#043555" },
  PVV_LE_p: { name: "PVV", color: "#043555" },
  past_vote_PVV: { name: "PVV", color: "#043555" },

  VVD_GE_p: { name: "VVD", color: "#0e2783" },
  VVD_LE_p: { name: "VVD", color: "#0e2783" },
  past_vote_VVD: { name: "VVD", color: "#0e2783" },

  GLpvdA_GE_p: { name: "GL–PvdA", color: "#920c19" },
  GLpvdA_LE_p: { name: "GL–PvdA", color: "#920c19" },
  past_vote_GLpvdA: { name: "GL–PvdA", color: "#920c19" },

  CDA_GE_p: { name: "CDA", color: "#339933" },
  CDA_LE_p: { name: "CDA", color: "#339933" },
  past_vote_CDA: { name: "CDA", color: "#339933" },

  OtherRight_GE_p: { name: "Other right", color: "#7393B3" },
  OtherRight_LE_p: { name: "Other right", color: "#7393B3" },
  past_vote_OtherRight: { name: "Other right", color: "#7393B3" },

  OtherLeft_GE_p: { name: "Other left", color: "#997570" },
  OtherLeft_LE_p: { name: "Other left", color: "#997570" },
  past_vote_OtherLeft: { name: "Other left", color: "#997570" },

  OtherCentre_GE_p: { name: "Other centre", color: "#999999" },
  OtherCentre_LE_p: { name: "Other centre", color: "#999999" },
  past_vote_OtherCentre: { name: "Other centre", color: "#999999" },

  // Not in your PARTY_INFO mapping, but present in your earlier config:
  past_vote_DidNotVote: { name: "Did not vote", color: "#94A3B8" },
};


// Build labels and colors in one go
const buildLabelsAndColors = () => {
  const labels = {};
  const colors = {};

  Object.entries(PARTY_INFO).forEach(([key, info]) => {
    labels[key] = info.name;
    colors[key] = info.color;
  });

  return { labels, colors };
};


const clamp01 = (x) => Math.max(0, Math.min(1, x));
const hexToHsl = (hex) => {
  let c = hex.replace("#",""); if (c.length===3) c = c.split("").map(x=>x+x).join("");
  const r=parseInt(c.slice(0,2),16)/255, g=parseInt(c.slice(2,4),16)/255, b=parseInt(c.slice(4,6),16)/255;
  const max=Math.max(r,g,b), min=Math.min(r,g,b); let h,s,l=(max+min)/2;
  if(max===min){h=s=0;} else {const d=max-min; s=l>0.5?d/(2-max-min):d/(max+min);
    switch(max){
    case r:h=(g-b)/d+(g<b?6:0);
      break;
    case g:h=(b-r)/d+2;
      break;
    case b:h=(r-g)/d+4;
      break;
    default:
      break;
    } h/=6;}
  return {h:Math.round(h*360), s:Math.round(s*100), l:Math.round(l*100)};
};
const hslToHex = (h,s,l) => {
  h/=360; s/=100; l/=100;
  const hue2rgb=(p,q,t)=>{ if(t<0)t+=1;if(t>1)t-=1;if(t<1/6)return p+(q-p)*6*t;if(t<1/2)return q;if(t<2/3)return p+(q-p)*(2/3-t)*6;return p; };
  const q=l<0.5?l*(1+s):l+s-l*s; const p=2*l-q;
  const r=Math.round(hue2rgb(p,q,h+1/3)*255), g=Math.round(hue2rgb(p,q,h)*255), b=Math.round(hue2rgb(p,q,h-1/3)*255);
  return "#"+[r,g,b].map(v=>v.toString(16).padStart(2,"0")).join("");
};
const clamp = (x, lo, hi) => Math.min(hi, Math.max(lo, x));
const clamp02 = (x) => clamp(x, 0, 1);

function lowerBound(arr, x) {
  // first index i where arr[i] >= x
  let lo = 0, hi = arr.length;
  while (lo < hi) {
    const mid = (lo + hi) >> 1;
    if (arr[mid] < x) lo = mid + 1;
    else hi = mid;
  }
  return lo;
}

const makeHeatScale = (
  baseHex,
  values,
  {
    qLow = 0.01,          // trim tails (outliers)
    qHigh = 0.99,
    lightMin = 40,
    lightMax = 95,
    gamma = 0.85,          // 1 = linear in percentile space
    missing = "#CCCCCC",
    minSat = 35,
    neutralSatCutoff = 6, // keep greys grey
  } = {}
) => {
  const finite = values.filter(Number.isFinite).slice().sort((a, b) => a - b);
  const n = finite.length;
  if (!n) return () => missing;

  const { h, s } = hexToHsl(baseHex);
  const sat = s <= neutralSatCutoff ? 0 : Math.max(s, minSat);

  // Precompute indices for trimming (winsorising in percentile space)
  const loIdx = Math.floor((n - 1) * qLow);
  const hiIdx = Math.floor((n - 1) * qHigh);
  const denom = Math.max(1, hiIdx - loIdx);

  return (v) => {
    if (!Number.isFinite(v)) return missing;

    // percentile rank via binary search
    const idx = lowerBound(finite, v);

    // trim tails to avoid outliers dominating colour range
    const clippedIdx = clamp(idx, loIdx, hiIdx);

    // continuous position within the trimmed range
    let t = (clippedIdx - loIdx) / denom;
    t = Math.pow(clamp02(t), gamma);

    const light = lightMax - t * (lightMax - lightMin);
    return hslToHex(h, sat, light);
  };
};


const make2pointHeatScale = (baseHexPos, baseHexNeg, values) => {
  const finite = values.filter(v => Number.isFinite(v));
  const min = finite.length ? Math.min(...finite) : 0;
  const max = finite.length ? Math.max(...finite) : 100;

  return (v) => {
    if (!Number.isFinite(v)) return "#CCCCCC";

    if (v >= 0) {
      // Positive side
      const { h, s } = hexToHsl(baseHexPos);
      const t = clamp01(v / Math.max(1e-6, max)); // normalise 0 → max
      const light = 95 - t * 60;
      return hslToHex(h, s, light);
    } else {
      // Negative side
      const { h, s } = hexToHsl(baseHexNeg);
      const t = clamp01(v / Math.min(-1e-6, min)); // normalise 0 → min (negative)
      const light = 95 - t * 60;
      return hslToHex(h, s, light);
    }
  };
};



class NZ2026SeatComparison extends Component {
      constructor(props) {
    super(props);
    this.state = {
      geoLevel: "geementen",
      metricRows: null, 
      loading: false,
      hoverInfo: null,
      hoverAreaId: null,
      selectedStateBounds: null,
      selectedFeature: null,   
      geoData:props.GEEMENTENMap,
      styleLoaded: false,
      viewState: null,
      metricRowsConst: null,
      metricRowsNational:null,
      chosenParty:"D66_GE_p",
      chosenView:"change",
      scatterDemogsRows:null,
      polLevel:"GE"
    };
    
    this.mapRef = React.createRef();
    this._inflight = null; 
    this._lastKey = null;
    this._lastAt = 0;

    
  }

  
  componentDidMount() {
  const run = async () => {
    await this.fetchMetrics("national", null, true);
    await this.fetchMetrics("geementen", null, true);
    this.fetchDemogsForScatter()
  };
  run();
}

   componentDidUpdate(prevProps, prevState) {
    const groupChanged      = prevProps.selectedGroupId !== this.props.selectedGroupId;
   
    const levelChanged      = prevState.geoLevel !== this.state.geoLevel;

    const chosenPartychange = prevState.chosenParty !== this.state.chosenParty;
    const chosenViewchange = prevState.chosenView !== this.state.chosenView;
    const polLevelChanged      = prevState.polLevel !== this.state.polLevel;

  
    const needRefetch = levelChanged  || groupChanged ;
    if (needRefetch) {
      this.fetchMetrics(this.state.geoLevel, this.state.selectedFeature?.area_id);
    }

  
    const rowsChanged  = prevState.metricRows !== this.state.metricRows;
    const geoChanged   = prevState.geoData !== this.state.geoData;
  
    if (geoChanged || rowsChanged || groupChanged || chosenPartychange ||chosenViewchange||polLevelChanged) {
      this.restyle();
    }
  
   
    
  }
  _inflightBaseline = null;
  _lastBaselineKey = null;
  _lastBaselineAt = 0;
    requestKey = (level) => {

    return `${level}`;
  };


  //main function that grabs data
    fetchMetrics = async (level, constCode, save_const_results) => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;

  const reqKey = this.requestKey(level);
  const now = Date.now();
  if (this._lastKey === reqKey && now - this._lastAt < 700) return;
  this._lastKey = reqKey;
  this._lastAt = now;


    let keysBody 
    if(level==="national"){
          keysBody= [
  "D66_GE_p",
            "PVV_GE_p",
            "VVD_GE_p",
            "GLpvdA_GE_p",
            "CDA_GE_p",
            "OtherRight_GE_p",
            "OtherLeft_GE_p",
            "OtherCentre_GE_p",
            "D66_LE_p",
            "PVV_LE_p",
            "VVD_LE_p",
            "GLpvdA_LE_p",
            "CDA_LE_p",
            "OtherRight_LE_p",
            "OtherLeft_LE_p",
            "OtherCentre_LE_p",
            "Local_LE_p",
            "D66_consider",
            "turnout_GE_p",
            "turnout_LE_p",
      "past_vote_CDA",
      "past_vote_D66",
      "past_vote_DidNotVote",
      "past_vote_GLpvdA",
      "past_vote_OtherCentre",
      "past_vote_OtherLeft",
      "past_vote_OtherRight",
      "past_vote_PVV",
      "past_vote_VVD"
                  ]  
    }else{
    keysBody= [
               "D66_GE_p",
            "PVV_GE_p",
            "VVD_GE_p",
            "GLpvdA_GE_p",
            "CDA_GE_p",
            "OtherRight_GE_p",
            "OtherLeft_GE_p",
            "OtherCentre_GE_p",
            "D66_LE_p",
            "PVV_LE_p",
            "VVD_LE_p",
            "GLpvdA_LE_p",
            "CDA_LE_p",
            "OtherRight_LE_p",
            "OtherLeft_LE_p",
            "OtherCentre_LE_p",
            "Local_LE_p",
            "D66_consider",
            "turnout_GE_p",
            "turnout_LE_p",
      "past_vote_CDA",
      "past_vote_D66",
      "past_vote_DidNotVote",
      "past_vote_GLpvdA",
      "past_vote_OtherCentre",
      "past_vote_OtherLeft",
      "past_vote_OtherRight",
      "past_vote_PVV",
      "past_vote_VVD"
                  ]
                }
                
     let turnout_weight
    turnout_weight = "turnout_GE_n"

    const body = {
      groupKeys: keysBody,
      filters:[],
      constCode: constCode,
      turnout_weight:turnout_weight
    };
  
    this.setState({ loading: true });
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/${level}_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);
      // --- update state with both ---
      if(save_const_results){
        if(level==="national"){
          this.setState(
             { metricRowsNational: rowsMain })
            }else{
            this.setState(
            { metricRowsConst: rowsMain ,
                metricRows: rowsMain,})
            }
      }else{
           this.setState({
        metricRows: rowsMain,
        loading: false,
        
      });
      }
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ metricRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }


  //main function that grabs data
    fetchDemogsForScatter = async () => {
  const controller = new AbortController(); // new controller for this call
  const signal = controller.signal;



    const body = {
      table: "scatter_demog"
    };
  
    this.setState({ loading: true });
  

 
    try {
      // --- call main metrics endpoint ---
          const resMain = await fetch(`/api/fulltable_data_arrow/`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(body),
                signal,
                });
      if (!resMain.ok) throw new Error(`metrics fetch ${resMain.status}`);
      const bufMain = await resMain.arrayBuffer();
      const tableMain = tableFromIPC(bufMain);
      const rowsMain = rowsFromTable(tableMain);
      console.log("scatterdemogsrows",rowsMain)
          this.setState(
             { scatterDemogsRows: rowsMain })
   
    } catch (e) {
      if (e.name !== "AbortError") console.error("metrics error:", e);
      this.setState({ scatterDemogsRows: null,  loading: false });
    } finally {
      this._inflight = null;
    }

  }

   restyle = () => {
    const { geoData, metricRows,polLevel} = this.state;

  
    if (!geoData) {
      this.setState({ styledGeo: null });
      return;
    }
      if (!metricRows) {
      return;
    }
    const byId = new Map();
    for (const r of metricRows) {
      const id = String(r.area_id ?? "");
      if (id) byId.set(id, r);
    }

    
    let heatScale
    let heatKey
   
    const { labels, colors } = buildLabelsAndColors();
    
    heatKey = this.state.chosenParty;
    

    const values = geoData.features.map(f => {
      const rid = String(f.properties?.area_id ?? "");
      const row = byId.get(rid);

      if(this.state.chosenView==="pred"){

    
      return row ? Number(row[heatKey]) : NaN;

      
    }else{
        
   
      return row ? Number(row[heatKey])-(Number(f.properties?.[heatKey.replace("_GE_p", "").replace("_LE_p", "").replace("past_vote_", "")])*100) : NaN;

      

    }

 
    });
    const base = PARTY_INFO[heatKey]?.color || "#6e6e6e";
    
    heatScale = this.state.chosenView==="change" ? make2pointHeatScale("#2E7D32","#C62828", values) : makeHeatScale(base, values);
 
    const styled = {
      type: "FeatureCollection",
      features: geoData.features.map(f => {
        const rid = String(f.properties?.area_id ?? "");
        const row = byId.get(rid);
        
  
        if (!row) {
          return {
            ...f,
            properties: {
              ...f.properties,
              fillColor: "#ffffff",
              topLabel: "No data",
              topValue: 0,
              _allValues: {},
              _allValuesSorted: [],
            }
          };
        }
        
        const groupKeys = getGroupKeys(polLevel);
  
        const displayKeys = (groupKeys || []).filter(k => k in row);
        if (displayKeys.length === 0) {
          return {
            ...f,
            properties: {
              ...f.properties,
              fillColor: "#ffffff",
              topLabel: "No data",
              topValue: 0,
              _allValues: {},
              _allValuesSorted: [],
            }
          };
        }
  
        const entries = displayKeys
          .map(k => ({
            key: k,
            area_name: labels[k] || k,
            area_id: Number(row[k]),
          }))
          .filter(e => Number.isFinite(e.area_id))
          .sort((a, b) => b.area_id - a.area_id);

  
        let fillColor = "#666";
        let topKey    = entries[0]?.key;
        let topLabel  = entries[0]?.area_name || "";
        let topValue  = entries[0]?.area_id || 0;

        let v;

            if(this.state.chosenView==="pred"){

                    v = Number(row[heatKey])

                }else{

                    v = Number(row[heatKey])-(Number(f.properties?.[heatKey.replace("_GE_p", "").replace("_LE_p", "").replace("past_vote_", "")])*100)

                


    }


        fillColor = heatScale(v);
        topKey    = heatKey;
        topLabel  = entries[0]?.area_name || "";
        topValue  = Number.isFinite(v) ? v : 0;

        let sortedvals

           sortedvals = entries
                  .map(e => ({
                    ...e,
                    order: e.key === "Net" ? Number.MAX_SAFE_INTEGER : 0 // net at bottom, others stay in original order
                  }))
                  .sort((a, b) => a.order - b.order)
                  .map(e => ({ key: e.key, area_name: e.area_name, area_id: e.area_id })); // remove order after sorting
     
        return {
          ...f,
          properties: {
            ...f.properties,
            fillColor,
            topKey,
            topLabel,
            topValue,
            _allValues: Object.fromEntries(entries.map(e => [e.key,e.area_name, e.area_id])),
            _allValuesSorted: sortedvals,
            Turnout: row?.turnout_1_p
          }
        };
      })
    };
  
    this.setState({ styledGeo: styled,styleLoaded: true });
  };

  fitBoundsFromFeatures = (features) => {
  if (!this.mapRef.current || !features?.length) return null;
  const map = this.mapRef.current.getMap();
  const bounds = new mapboxgl.LngLatBounds();
  this.setState({viewState:null})
  features.forEach(f => {
    const coords = f.geometry.type === "Polygon"
      ? f.geometry.coordinates.flat(1)
      : f.geometry.coordinates.flat(2);
    coords.forEach(([lng, lat]) => bounds.extend([lng, lat]));
  });
  map.fitBounds(bounds, { padding: 28, duration: 500 });
  return bounds;
};

  

   onMapClick = (evt) => {
    const feature = evt.features?.[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map = this.mapRef.current?.getMap();


    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);

    

    const clickedLevel = level;

    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map?.fitBounds(this.state.selectedStateBounds, { padding: 28, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.props.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }

     if (level === "geementen") {
      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateBounds = zoomToFeature(feature); // sets map to state
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "buurt",
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "geementen",
            key: "gemeentecode",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("buurt",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("buurt", { doFit: false });
                
  
        }
      );
      return;
    }


  };

      onMouseMove = (evt) => {
        const feature = evt.features && evt.features[0];
        if (!feature) return this.setState({ hoverInfo: null,hoverAreaId:null });
    
        const { lng, lat } = evt.lngLat; 
        this.setState({
        hoverInfo: { lon: lng, lat, props: feature.properties },
        hoverAreaId: feature.properties.area_id ?? null
        });
    };

  loadGeo = async (level) => {
    let newGeo 
    switch(level){
        case "geementen":
         newGeo = this.props.GEEMENTENMap
        break
        case "buurt":
         newGeo = this.props.BUURTMap
        break
        default:
         newGeo = this.props.GEEMENTENMap
        break
    }
    console.log("newGeo=",newGeo)
    this.setState({geoData: newGeo, geoLevel: level
    })
  }

 onGeoLevelChange = (newLevel) => {
  if (!newLevel) return;

  // if these are async functions already, await them
  this.fetchMetrics(newLevel, this.state.selectedFeature?.area_id);
  this.loadGeo(newLevel);

  // return when both finish
};
    // Utility: compute bounds [minX, minY, maxX, maxY] from a FeatureCollection
getFeatureCollectionBounds = (featureCollection) => {
  let minX = Infinity, minY = Infinity, maxX = -Infinity, maxY = -Infinity;

  featureCollection.features.forEach((feat) => {
    const coords = feat.geometry.coordinates;

    const recurse = (arr) => {
      if (typeof arr[0] === "number") {
        const [x, y] = arr;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      } else {
        arr.forEach(recurse);
      }
    };

    recurse(coords);
  });

  return [[minX, minY], [maxX, maxY]];
};
    

   resetView = ({ LevelToResetTo = "geementen" }) => {
    const map = this.mapRef.current?.getMap();
    if (map) {
    map.fitBounds(
      [
      [3.3, 50.7],  // SW (south-west)
      [7.2, 53.6],  // NE (north-east)
      ],
      { padding: 80 }
    );
  }

  this.setState(
    {
      geoLevel: LevelToResetTo,
      selectedStateCode: null,
      selectedStateBounds: null,
      selectedFeature: null,
      metricRows: null,
      styledGeo: null,
            
    },
    () => {
      this.onGeoLevelChange(LevelToResetTo);

    }
  );
};

handleselectedFeatureChange =  (area_id, area_name) => {

  


    const feature = this.props.constituencyMap.features.filter(
          f => String(f.properties.area_id) === String(area_id.area_id)
        )[0];
    if (!feature) return;
    const level = this.state.geoLevel;
    const p = feature.properties || {};
    const areaId = String(p.area_id ?? "");
    const map = this.mapRef.current?.getMap();

    const zoomToFeature = (feat) => this.fitBoundsFromFeatures([feat]);   

    const clickedLevel = level;


    if (
      areaId &&
      this.state.selectedFeature &&
      this.state.selectedFeature.level === clickedLevel &&
      this.state.selectedFeature.area_id === areaId
    ) {
      this.setState({ selectedFeature: null }, () => {
        if (this.state.selectedStateBounds) {
          map?.fitBounds(this.state.selectedStateBounds, { padding: 28, duration: 500 });
        } else {
         // map?.fitBounds([[-125, 24], [-66, 49]], { padding: 20, duration: 500 });
        }

        this.props.onFeatureSelect?.({
          feature: null,
          selectedAreaLabel: null,
          selectedFeatureLevel: null,
        });
      });
      return;
    }
      const stateBounds = zoomToFeature(feature); // sets map to state

      const constCode = String(p.area_id || "")
      if (!constCode) return;
  
      const stateLabel =  p.area_name;
  
      this.setState(
        {
          selectedconstCode: constCode,
          selectedStateBounds: stateBounds,
          geoLevel: "buurt",
          viewState:null,
          // Keep selectedFeature pointing to the state context
          selectedFeature: {
            level: "geementen",
            key: "gemeentecode",
            area_id: constCode,
            area_name: stateLabel,
            rowMatchIds: [constCode],
            
          },
        },
        () => {
          // Make sure county metrics (and secondary metrics) are loaded for tooltips
          this.fetchMetrics("buurt",constCode );
          // Load county geo for that state (no auto-fit; we already zoomed)
          this.loadGeo("buurt", { doFit: false });
                
  
        }
      );
      return;
    
 

}
  handlechosenPartyChange     = (val) => this.setState({ chosenParty: val });
  handlechosenViewChange     = (val) => this.setState({ chosenView: val });
     onPolLevelChange = (newLevel) => {
  if (!newLevel) return;
  const keys = getGroupKeys(newLevel);
  const nextChosen = keys.includes(this.state.chosenParty) ? this.state.chosenParty : keys[0];

  
    this.setState({polLevel: newLevel,
    chosenParty: nextChosen
    })

  // return when both finish
};

  render() {
    const partyKeys = getGroupKeys(this.state.polLevel);

  return(
    <>
  <Box sx={{ height: "92vh", display: "flex", flexDirection: "column", width:'100%' }}>
    {/* HEADER (auto height, no flexGrow) */}
    <Box
      sx={(theme) => ({
        px: 3, py: 3,
        display: "flex", alignItems: "center",
        backgroundColor: theme.vars
          ? `rgba(${theme.vars.palette.background.defaultChannel} / 1)`
          : theme.palette.background.default,
        borderBottom: `1px solid ${theme.palette.divider}`,
        // no flexGrow, no % height here
      })}
    >
      {/* left: icon + text */}
      <Stack direction="row" spacing={2} alignItems="center" sx={{ ml: 4 }}>
        <Avatar
          variant="square"
          src={`${process.env.PUBLIC_URL}/static/images/logo.png`}
          alt="Projected Vote Shares"
          sx={{
            width: 44, height: 44, flexShrink: 0,
            bgcolor: "transparent",
            "& .MuiAvatar-img": { objectFit: "contain" },
          }}
        />
        <Box>
          <Typography variant="h5" fontWeight={700}>Projected Vote Shares</Typography>
          <Typography variant="body1" color="text.secondary">
            Select a party from the list below to display their heat maps
          </Typography>
        </Box>
      </Stack>

      {/* right: selects */}
      <Stack direction="row" alignItems="center" spacing={2} sx={{ ml: "auto", pr: 4 }}>
           <TextField
                    select
                    label="Party"
                    size="small"
                    value={this.state.chosenParty}
                    onChange={(e) => this.handlechosenPartyChange?.(e.target.value)}
                    sx={{ minWidth: 180 }}
                    >
  {partyKeys.map((key) => (
    <MenuItem key={key} value={key}>
      {PARTY_INFO[key]?.name ?? key}
    </MenuItem>
  ))}
</TextField>

                    <TextField
                    select
                    label="View"
                    size="small"
                    value={this.state.chosenView}
                    onChange={(e) => this.handlechosenViewChange?.(e.target.value)}
                    sx={{ minWidth: 180 }}
                    >
                    <MenuItem value="pred">Predicted vote share</MenuItem>
                    <MenuItem value="change">Change since 2025</MenuItem>
                    </TextField>


      </Stack>
    </Box>

    {/* CONTENT: fills the rest, split 50/50 */}
    <Box
      sx={{
        flex: 1,
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        overflow: "hidden",
        width:"100%"
      }}
    >
      {/* LEFT PANEL (map) */}
      <Box sx={{ minWidth: 0, overflow: "hidden" }}>
        <Box sx={{ width: "100%", height: "100%" }}>
          <MapComponent
            mapRef={this.mapRef}
            styledGeo={this.state.styledGeo}
            geoData={this.state.geoData}
            hoverInfo={this.state.hoverInfo}
            styleLoaded={this.state.styleLoaded}
            selectedFeature={this.state.selectedFeature}
            onMapClick={this.onMapClick}
            onMouseMove={this.onMouseMove}
            onPolLevelChange={this.onPolLevelChange}
            onGeoLevelChange={this.onGeoLevelChange}
            buildLabelsAndColors={buildLabelsAndColors}
            geoLevel={this.state.geoLevel}
            resetView={this.resetView}
            handleselectedFeatureChange={this.handleselectedFeatureChange}
            viewState={this.state.viewState}
            tooltip = {"seatcomp"}
            chosenView = {this.state.chosenView}
            chosenParty = {this.state.chosenParty}
          />
        </Box>
      </Box>

      {/* RIGHT PANEL */}
      <Box sx={{ minWidth: 0, overflow: "auto", borderLeft: 1, borderColor: "divider" }}>
        <ScatterDemogsChart
        scatterDemogsRows={this.state.scatterDemogsRows}
        selectedParty={this.state.chosenParty}
        polLevel={this.state.polLevel}
        />
      </Box>
    </Box>
  </Box>
</>

  )
}


  }

export default withRouter(NZ2026SeatComparison);